import dayjs from 'dayjs'
import advancedFormat from 'dayjs/plugin/advancedFormat'
import arraySupport from 'dayjs/plugin/arraySupport'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import dayOfYear from 'dayjs/plugin/dayOfYear'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import pluralGetSet from 'dayjs/plugin/pluralGetSet'
import quarterOfYear from 'dayjs/plugin/quarterOfYear'
import relativeTime from 'dayjs/plugin/relativeTime'
import toArray from 'dayjs/plugin/toArray'
import toObject from 'dayjs/plugin/toObject'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'
import weekOfYear from 'dayjs/plugin/weekOfYear'
import weekYear from 'dayjs/plugin/weekYear'
import weekday from 'dayjs/plugin/weekday'
import isBetween from 'dayjs/plugin/isBetween'
import isLeapYear from 'dayjs/plugin/isLeapYear'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
import isToday from 'dayjs/plugin/isToday'
import isTomorrow from 'dayjs/plugin/isTomorrow'
import isYesterday from 'dayjs/plugin/isYesterday'
import isoWeek from 'dayjs/plugin/isoWeek'
import isoWeeksInYear from 'dayjs/plugin/isoWeeksInYear'
import bigIntSupport from 'dayjs/plugin/bigIntSupport'
import minMax from 'dayjs/plugin/minMax'
// https://github.com/iamkun/dayjs/tree/dev/src/locale
import 'dayjs/locale/uk'

dayjs.locale('uk')

dayjs.extend(bigIntSupport)
dayjs.extend(isoWeeksInYear)
dayjs.extend(isoWeek)
dayjs.extend(isYesterday)
dayjs.extend(isTomorrow)
dayjs.extend(isToday)
dayjs.extend(isSameOrBefore)
dayjs.extend(isSameOrAfter)
dayjs.extend(isLeapYear)
dayjs.extend(advancedFormat)
dayjs.extend(arraySupport)
dayjs.extend(customParseFormat)
dayjs.extend(dayOfYear)
dayjs.extend(isBetween)
dayjs.extend(localizedFormat)
dayjs.extend(pluralGetSet)
dayjs.extend(quarterOfYear)
dayjs.extend(relativeTime)
dayjs.extend(timezone)
dayjs.extend(toArray)
dayjs.extend(toObject)
dayjs.extend(utc)
dayjs.extend(weekOfYear)
dayjs.extend(weekYear)
dayjs.extend(weekday)
dayjs.extend(minMax)

export const dt = dayjs
